/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Address, HexString, Val, Struct } from "@alephium/web3";
import { default as allStructsJson } from "../structs.ral.json";
export const AllStructs = allStructsJson.map((json) => Struct.fromJson(json));
export interface CollectParams extends Record<string, Val> {
  token0: HexString;
  token1: HexString;
  configIndex: bigint;
  owner: Address;
  recipient: Address;
  tickLower: bigint;
  tickUpper: bigint;
  amount0Max: bigint;
  amount1Max: bigint;
}
export interface Config extends Record<string, Val> {
  tickSpacing: bigint;
  fee: bigint;
  feeProtocol: bigint;
}
export interface DecreaseLiquidityParams extends Record<string, Val> {
  token0: HexString;
  token1: HexString;
  configIndex: bigint;
  owner: Address;
  tickLower: bigint;
  tickUpper: bigint;
  amount0Min: bigint;
  amount1Min: bigint;
}
export interface ModifyLiquidityParams extends Record<string, Val> {
  token0: HexString;
  token1: HexString;
  configIndex: bigint;
  owner: Address;
  tickLower: bigint;
  tickUpper: bigint;
  amount0Desired: bigint;
  amount1Desired: bigint;
  amount0Min: bigint;
  amount1Min: bigint;
}
export interface ModifyPositionParams extends Record<string, Val> {
  owner: Address;
  tickLower: bigint;
  tickUpper: bigint;
  liquidityDelta: bigint;
}
export interface PositionInfo extends Record<string, Val> {
  amount0: bigint;
  amount1: bigint;
  fees: [bigint, bigint, bigint];
  avgValue: bigint;
  avgFees: bigint;
  avgTime: bigint;
}
export interface ProtocolFees extends Record<string, Val> {
  token0: bigint;
  token1: bigint;
}
export interface Reward extends Record<string, Val> {
  nextOpenTime: bigint;
  endTime: bigint;
  amount: bigint;
}
export interface Slot0 extends Record<string, Val> {
  sqrtPriceX96: bigint;
  tick: bigint;
  feeProtocol: bigint;
}
export interface StepComputations extends Record<string, Val> {
  sqrtPriceStartX96: bigint;
  tickNext: bigint;
  initialized: boolean;
  sqrtPriceNextX96: bigint;
  amountIn: bigint;
  amountOut: bigint;
  feeAmount: bigint;
}
export interface SwapCache extends Record<string, Val> {
  liquidityStart: bigint;
  feeProtocol: bigint;
}
export interface SwapParams extends Record<string, Val> {
  payer: Address;
  recipient: Address;
  token: HexString;
  payToken: HexString;
  toPay: bigint;
  withdrawToken: HexString;
  toWithdraw: bigint;
  data: HexString;
}
export interface SwapState extends Record<string, Val> {
  amountSpecifiedRemaining: bigint;
  amountCalculated: bigint;
  sqrtPriceX96: bigint;
  tick: bigint;
  feeGrowthGlobalX128: bigint;
  liquidity: bigint;
  protocolFee: bigint;
}
